'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = require('./analytics.html');

var _analytics2 = _interopRequireDefault(_analytics);

var _analytics3 = require('./analytics.controller');

var _analytics4 = _interopRequireDefault(_analytics3);

require('./analytics.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template: _analytics2.default,
  controller: _analytics4.default,
  controllerAs: 'vm'
};

exports.default = analyticsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics/analytics.component.js
 **/